import type { ValidationState } from '../../state/validationState';

const hasValidationErrors = (validatedFeedback: ValidationState): boolean => {
  for (const errors of validatedFeedback.values()) {
    if (errors.length > 0) {
      return true;
    }
  }
  return false;
};

export default hasValidationErrors;
